exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span[data-v-616922d6]{font-size:13px}.span-detail-info[data-v-616922d6]{color:#1f4a98}", ""]);

// exports
